export default __webpack_public_path__ + "static/media/Group 5636.97e78293.svg";